/**
 * @author        luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright     Copyright (c) 2022, Zumper
 */

export const HEADER_TEXT = 'Find your fresh start'
export const HEADER_TEXT_ZUMPER_RENTALS = 'Find your forever. Or your for now.'
export const SUBHEADER_TEXT = 'Discover millions of houses and apartments for rent.'
export const SUBHEADER_TEXT_ZUMPER_RENTALS = 'Browse millions of rentals.'
export const AUTOCOMPLETE_PLACEHOLDER = 'Search by city or neighborhood'
export const NEW_AUTOCOMPLETE_PLACEHOLDER = 'Search by location or property name'
